import { render } from "./MultiVideoPart.vue?vue&type=template&id=7c971238&scoped=true&ts=true"
import script from "./MultiVideoPart.vue?vue&type=script&lang=ts"
export * from "./MultiVideoPart.vue?vue&type=script&lang=ts"

import "./MultiVideoPart.vue?vue&type=style&index=0&id=7c971238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c971238"]])

export default __exports__